import { useState } from 'react';
import ExpandButton from 'components/molecules/expand-button';
import CollapseAnimation from 'components/atoms/base-animations/collapse';
import { useTranslation } from 'react-i18next';
import { languagesMap } from 'constants/languages';

import s from './styles.module.scss';
import ChartCardItem from './chart-card-item';

import type { FC } from 'react';
import type { ISmsCampaignSummaryResponse } from 'infrastructure/interfaces';

interface CardProps {
  data: ISmsCampaignSummaryResponse;
}

const Card: FC<CardProps> = ({ data }) => {
  const [expanded, setExpanded] = useState(true);
  const { t } = useTranslation();

  const total = data.questions.reduce((acc, question) => {
    const itemValue = question.items.reduce((a, item) => a + item.value, 0);
    return acc + itemValue;
  }, 0);

  return (
    <div className={s.card}>
      <div className={s.header}>
        <p className={s.title}>
          <p>
            <span>{t('labels.status')}: </span> {data.groupName}
          </p>
          <p>
            <span>{t('labels.language')}:</span> {languagesMap[data.language]}
          </p>
        </p>
        <div className={s.total}>
          {t('labels.totalAnswers')}: {total}
        </div>
        <ExpandButton
          expanded={expanded}
          className={s['expand-btn']}
          dataCy={`toggle-${data.groupName}-btn`}
          onClick={() => setExpanded(!expanded)}
        />
      </div>
      <CollapseAnimation opened={expanded} className={s.collapse}>
        <div className={s.questions}>
          {data.questions.map((question, index) => (
            <ChartCardItem
              key={index}
              title={question.title}
              items={question.items}
            />
          ))}
        </div>
      </CollapseAnimation>
    </div>
  );
};
export default Card;
